import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts"

const OfficeWiseChart = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart 
        data={data}
        margin={{ top: 0, right: 0, left: -10 }}
    >
      <XAxis dataKey="officeName" tick={{ fontSize: 8 }} angle={-30} textAnchor="end" />
      <YAxis />
      <Tooltip />
     <Bar 
        dataKey="totalGrievances"
        fill="#004877" 
        barSize={20}
        // radius={[10, 10, 10, 10]}
      />
    </BarChart>
  </ResponsiveContainer>
)

export default OfficeWiseChart
